<template>
    <page-loader v-if="loadStatus == 'loading'" />
    <div v-else class="contain-section">
        <div class="row">
            <div class="col-12">
                <div class="classical-ancestry-menu">
                    <div :class="filter === 'overview' ? 'selected' : ''" @click="setFilter('overview')">
                        Overview
                    </div>
                    <div :class="filter === 'result' ? 'selected' : ''" @click="setFilter('result')">
                        Result
                    </div>
                    <div :class="filter === 'map' ? 'selected' : ''" @click="setFilter('map')">
                        Map
                    </div>
                    <div :class="filter === 'references' ? 'selected' : ''" @click="setFilter('references')">
                        References
                    </div>
                </div>
            </div>
        </div>
        <div v-if="filter == 'overview'" class="row">
            <div class="col-sm-12 col-md-12 col-lg-7 col-xl-8">
                <div class="inner-box">
                    <div class="banner-box">
                        <img class="rounded-4 h-400 img-row-feedback"
                            :src="overview && overview.main_image ? overview.main_image[0].url : ''" alt="Logo" />
                    </div>
                    <div class="inner-content">
                        <h3 class="mb-3 mt-0 ml-0">{{ overview ? overview.heading : '' }}</h3>
                        <div v-html="overview ? overview.text : ''">
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-5 col-xl-4">
                <div class="right-bar">
                    <div class="population-group p-0">
                        <div class="result-detail">
                            <div class="left">
                                <h4>{{ overview?.right_section && overview.right_section.length > 0 ?
                                    overview.right_section[0].heading : '' }}</h4>
                                <div class="m-0 mb-2"
                                    v-html="overview?.right_section && overview.right_section.length > 0 ? overview.right_section[0].text : ''">
                                </div>
                                <div @click="setFilter('result')" class="load-btn m-auto">
                                    {{ overview?.right_section && overview.right_section.length > 0 ?
                                        overview.right_section[0].button_text : '' }}
                                </div>
                            </div>
                            <div class="percentage-area">
                                <div class="percentage-area-rowx">
                                    <DoughnutChart :chart-data="chartData" :options="options"
                                        :ChartColor="getClassicalColour('greek')"
                                        :centerTitle="result?.greeks?.index?.toFixed(2)" centerSubtitle=""
                                        chartWidth="100%" chartHeight="100%" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="population-group">
                        <h4>{{ overview?.right_section && overview.right_section.length > 0 ?
                            overview.right_section[1].heading : '' }}</h4>
                        <div
                            v-html="overview?.right_section && overview.right_section.length > 0 ? overview.right_section[1].text : ''">
                        </div>
                        <img
                            :src="overview?.right_section && overview.right_section.length > 0 ? overview.right_section[1].main_image[0].url : ''" />
                        <div @click="setFilter('map')" class="load-btn m-auto">
                            {{
                                overview?.right_section && overview.right_section.length > 0 ?
                                    overview.right_section[1].button_text : '' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <GreekMap v-if="filter == 'map'" :introduction="introduction" :sample-group="sampleGroup"
            :sample-sites="sampleSites" />
        <GreekReferences v-if="filter == 'references'" :reference="reference" />
        <GreekResult v-if="filter == 'result'" @action="action" />
    </div>
</template>
<script setup>
import "../../../../styles/pages/ancentry/recent-ancetry.scss";
import { ref, provide, computed, onMounted } from "vue";
import GreekResult from "./GreekResult.vue";
import GreekMap from "./GreekMap.vue";
import GreekReferences from "./GreekReferences.vue";
import { getClassicalGreekOverview, getClassicalGreekReference } from "@/services/classical";
import store from "@/store/index";
import { getRequiredContent, getClassicalColour } from "@/composables/useClassicalContent";
import DoughnutChart from "@/components/charts/Doughnut.vue";

const action = () => {
    setFilter("map");
};
let filter = ref("overview");
const result = store.getters.result;
provide("greek-result", result);

const introduction = ref({});
const sampleGroup = ref({});
const sampleSites = ref({});

const loadStatus = ref("loading");
const overview = ref({});
const reference = ref({});

onMounted(async () => {
    overview.value = await getClassicalGreekOverview();
    reference.value = await getClassicalGreekReference();
    loadStatus.value = "loaded";
});

getRequiredContent([
    "greek-introduction",
    result.greeks.closest_sample.slug,
    "sample-site-locations",
])
    .then(([introductionResult, sampleGroupResult, sampleSitesResult]) => {
        introduction.value = introductionResult;
        sampleGroup.value = sampleGroupResult;
        sampleSites.value = sampleSitesResult;
    })
    .finally();

const setFilter = (filterValue) => {
    filter.value = filterValue;
};
const options = {
    cutout: "70%",
    radius: "100%",
    responsive: true,
    maintainAspectRatio: true,
};

const chartData = computed(() => ({
    cutoutPercentage: 10,
    datasets: [
        {
            data:
                result?.greeks?.index <= 100
                    ? [result?.greeks?.index, 100 - result?.greeks?.index]
                    : [100, 0],
            backgroundColor: [getClassicalColour("greek"), "#ddd"],
        },
    ],
    labels: [],
}));
</script>
